export default __webpack_public_path__ + "6edf9b4ea24b126986de8d8d9a7a6dab.png";